import React, { HTMLAttributes } from 'react';
import { View } from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import EntitiesHighlighted from '../../../components/EntitiesHighlighted';
import { ParagraphPartnersHighlights as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphPartnersHighlightsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphPartnersHighlights: React.FC<ParagraphPartnersHighlightsProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;
  const link = paragraph.field_link[0];
  const linkTitle = link?.title;
  const linkUri = link?.alias || link?.uri;

  return (
    <div className="Paragraph ParagraphPartnersHighlights">
      <Container>
        <div className="row">
          <div className="col-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2">
            <EntitiesHighlighted
              title={title}
              body={body}
              link={linkUri}
              linkTitle={linkTitle}
              linkPosition="left"
            >
              <View
                id="partners"
                display="highlights"
              />
            </EntitiesHighlighted>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphPartnersHighlights;
